<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>
<style lang="less">
#app {
  font-family: 'Microsoft Yahei','Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
*, *:before, *:after {
  box-sizing: border-box;
}
html,body{
  font-size: 14px;
  width: 100%;
  height: 100%;
}
.wrap{
    width: 1200px;
    margin: 0 auto;
    
    //用于开发测试
    // background-color: pink;
}
</style>




// WEBPACK FOOTER //
// src/App.vue